<!-- SPDX-FileCopyrightText: © 2024 Schneider Electric SPDX-License-Identifier: Apache-2.0 -->
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13 7.5H3.01v1H13z"/></svg>